import { MembershipDetails } from '@com-delta-idp/mnx-sky-club-ui';
import { AddToCartRequest, CURRENCY, MILES } from '../models';

export const getAddToCartRequest = (
  detail: MembershipDetails
): AddToCartRequest => {
  const addToCartRequest: AddToCartRequest = {
    code: detail.code,
    description: detail.membershipDescription,
    contractTypeCode: detail.contractTypeCode,
    feeInMiles:
      detail.denomination === MILES.trim() ? detail.shoppingValue : null,
    feesInCurrency:
      detail.denomination === CURRENCY ? detail.shoppingValue : null,
    currencyCode: detail.currencyCode,
    expirationDate: {
      year: new Date(detail.expirationDate).getFullYear(),
      month: new Date(detail.expirationDate).getMonth(),
      day: new Date(detail.expirationDate).getDate(),
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    }
  };
  return addToCartRequest;
};
